import type { MediaEntry } from '../../lib/mediaEntries';
import DocumentCard from './DocumentCard';
import EmptyState from './EmptyState';
import SectionCard from './SectionCard';

interface DocumentSectionProps {
  accent: 'brand' | 'error';
  emptyText: string;
  entries: MediaEntry[];
  isDeleting: boolean;
  onDownload: (entry: MediaEntry) => void;
  onRequestDuplicate: (entry: MediaEntry) => void;
  onRequestDelete: (entry: MediaEntry) => void;
  onRequestRename: (entry: MediaEntry) => void;
  onUpload: () => void;
  subtitle?: string;
  title: string;
}

const DocumentSection = ({
  accent,
  emptyText,
  entries,
  isDeleting,
  onDownload,
  onRequestDuplicate,
  onRequestDelete,
  onRequestRename,
  onUpload,
  subtitle,
  title,
}: DocumentSectionProps) => (
  <SectionCard count={entries.length} onUpload={onUpload} subtitle={subtitle} title={title}>
    {entries.length === 0 ? (
      <EmptyState text={emptyText} />
    ) : (
      <div className="grid gap-4 p-6 sm:grid-cols-2 xl:grid-cols-4">
        {entries.map((entry) => (
          <DocumentCard
            key={entry.id}
            accent={accent}
            entry={entry}
            isDeleting={isDeleting}
            onDownload={() => onDownload(entry)}
            onRequestDuplicate={() => onRequestDuplicate(entry)}
            onRequestDelete={() => onRequestDelete(entry)}
            onRequestRename={() => onRequestRename(entry)}
          />
        ))}
      </div>
    )}
  </SectionCard>
);

export default DocumentSection;
